import { format, formatDistanceToNow } from 'date-fns';
import { toDate } from 'date-fns-tz';

export interface EventTime {
  localTime: string;       // yyyy-mm-dd HH:mm format
  utcTimestamp: number;    // UTC timestamp for system operations
  timezone: string;        // Event location timezone
}

export function createEventTime(date: Date, timezone: string): EventTime {
  const localDate = toDate(date, { timeZone: timezone });
  
  return {
    localTime: format(localDate, 'yyyy-MM-dd HH:mm'),
    utcTimestamp: Math.floor(date.getTime() / 1000),
    timezone
  };
}

export function formatEventTime(eventTime: EventTime, userTimezone: string): string {
  const date = toDate(new Date(eventTime.utcTimestamp * 1000), { timeZone: userTimezone });
  return format(date, 'PPp');
}

export function getRelativeTime(timestamp: number): string {
  return formatDistanceToNow(timestamp * 1000, { addSuffix: true });
}

export function getCurrentTimezoneOffset(): string {
  const offset = new Date().getTimezoneOffset();
  const hours = Math.abs(Math.floor(offset / 60));
  const minutes = Math.abs(offset % 60);
  const sign = offset <= 0 ? '+' : '-';
  
  return `${sign}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}

// Helper to convert between local and UTC
export function localToUTC(localTime: string, timezone: string): number {
  const date = toDate(new Date(localTime), { timeZone: timezone });
  return Math.floor(date.getTime() / 1000);
}

export function utcToLocal(utcTimestamp: number, timezone: string): string {
  const date = toDate(new Date(utcTimestamp * 1000), { timeZone: timezone });
  return format(date, 'yyyy-MM-dd HH:mm');
}

export function formatLastActive(timestamp: number | undefined | null): string {
  if (!timestamp) return 'Never';
  return formatDistanceToNow(new Date(timestamp * 1000), { addSuffix: true });
}
